import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import Typography from '@material-ui/core/Typography';
// import ToggleButton from '@material-ui/lab/ToggleButton';
// import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import UserIcon from '@material-ui/icons/Person';
import { CardList } from 'grb-webui/components/Card';

import './APIKeyCards.scss';

const USER_KEYS = 'userkeys';
const NO_GROUP = 'none';

const DEFAULT_GOUP = 'license';

const APIKeyCards = (config = {}) => {
  const { className, groupOn = DEFAULT_GOUP, useUsage = true } = config;

  const SORTS = {
    createdAt: {
      id: 'createdAt',
      label: 'Date of creation',
      compare: (k1, k2) => (k1.createdAt - k2.createdAt),
    },
    license: {
      id: 'license',
      label: 'License',
      compare: (k1, k2) => ((k1.licenseId || '') - (k2.licenseId || '')),
    },
  };
  if (useUsage) {
    SORTS.usedAt = {
      id: 'usedAt',
      label: 'Date of last usage',
      compare: (k1, k2) => ((k2.usedAt || 0) - (k1.usedAt || 0)),
    };
  }

  const sortGroups = (first, groups) => {
    const keys = Object.keys(groups).slice();
    const index = first ? keys.indexOf(first) : -1;
    if (index >= 0) {
      keys.splice(index, 1);
    }
    return (index > -1 ? [groups[first]] : []).concat(keys.map(k => groups[k]).sort((g1, g2) => {
      if (g1.title < g2.title) {
        return -1;
      }

      if (g1.title > g2.title) {
        return 1;
      }

      return 0;
    }));
  };

  const makeGroups = ({ authService, viewService, getGroupIcon, noLicenseGroup = {}, licenses }) => ([
    {
      id: NO_GROUP,
      label: 'None',
      group: keys => [{ objects: keys }],
      sorts: [SORTS.license, SORTS.createdAt, useUsage && SORTS.usedAt].filter(x => x),
    },
    {
      id: 'license',
      label: 'Licenses',
      group: (keys) => {
        const groups = {};
        keys.forEach((k) => {
          const id = k.licenseId || USER_KEYS;
          if (!groups[id]) {
            groups[id] = {
              id,
              title: k.licenseId ? `License ${k.licenseId}` : (noLicenseGroup.title || 'User keys'),
              icon: getGroupIcon ? getGroupIcon('license', k, licenses) : (k.licenseId && viewService.getIcon('Licenses') || noLicenseGroup.icon || UserIcon),
              objects: [k],
            };
          } else {
            groups[id].objects.push(k);
          }
        });
        return sortGroups(USER_KEYS, groups);
      },
      sorts: [useUsage && SORTS.usedAt, SORTS.createdAt].filter(x => x),
    },
    {
      id: 'owners',
      label: 'Owners',
      group: (keys) => {
        const groups = {};
        keys.forEach((k) => {
          const id = k.user.email;
          if (!groups[id]) {
            groups[id] = {
              id,
              title: k.user.email,
              icon: getGroupIcon ? getGroupIcon('owners', k) : UserIcon,
              objects: [k],
            };
          } else {
            groups[id].objects.push(k);
          }
        });
        return sortGroups(authService.getEmail(), groups);
      },
      sorts: [SORTS.createdAt, useUsage && SORTS.usedAt, SORTS.license].filter(x => x),
    },
  ]);

  const APIKeyCardsComp = (props) => {
    const [group] = useState(groupOn);
    const [groups] = useState(() => makeGroups({ ...props, ...config }));
    const [groupByIds] = useState(() => {
      const byIds = {};
      groups.forEach((g) => { byIds[g.id] = g; });
      return byIds;
    });
    const [sortIndex] = useState(0);

    // const handleGroup = (event, newGroup) => {
    //   if (newGroup) {
    //     setGroup(newGroup);
    //     setSortIndex(0);
    //   }
    // };

    // const handleSort = (event, newSort) => {
    //   if ((newSort !== undefined) && (newSort !== null)) {
    //     setSortIndex(newSort);
    //   }
    // };

    return (
      <div className={classnames('grb-api-key-cards', className)}>
        <CardList
          {...props}
          getGroups={group === NO_GROUP ? undefined : groupByIds[group].group}
          compare={groupByIds[group].sorts[sortIndex].compare}
          emptyMessage="No API Keys"
          column
        />
      </div>
    );
  };

  APIKeyCardsComp.propTypes = {
    authService: PropTypes.shape({
      getProfile: PropTypes.func,
    }).isRequired,
    viewService: PropTypes.shape({
      getIcon: PropTypes.func,
    }).isRequired,
  };
  return APIKeyCardsComp;
};

export default APIKeyCards;
